// https://atlassian-2y.sentry.io/settings/projects/css-xp-partner-central-ui/keys/
export const SENTRY_DSN_FOR_PPC_UI =
  'https://4db233aabe5b48f88151d8e1ba228e07@o55978.ingest.us.sentry.io/4504445692018688';
